import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import ServiceScope from './components/ServiceScope';
import Philosophy from './components/Philosophy';
import Projects from './components/Projects';
import Careers from './components/Careers';
import News from './components/News';
import Contact from './components/Contact';
import CompanyOverview from './components/CompanyOverview';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

export default function HomePage() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <div className="bg-white">
      <Header isScrolled={isScrolled} />
      <main className="pt-16">
        <Hero onContactClick={openContactModal} />
        <Services />
        <ServiceScope />
        <Philosophy />
        <Projects />
        <Careers onContactClick={openContactModal} />
        <News />
        <Contact onContactClick={openContactModal} />
        <CompanyOverview />
      </main>
      <Footer />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
}
